export default __webpack_public_path__ + "static/media/onboarding_splash.24488959.png";